import { BoxDocumentApi } from "./api.box";
import { CloudDocumentApi } from "./api.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseDocumentApi } from "./api.base";
import environment from "@/config";

export default getService<BaseDocumentApi>(environment.nexus, {
    box: new BoxDocumentApi(),
    cloud: new CloudDocumentApi(),
});